import { Breakpoint, Dialog } from '@mui/material';
import { LoadingSpinner } from './LoadingSpinner';

interface IProps {
  fullWidth?: boolean;
  maxWidth?: Breakpoint | false;
  scroll?: 'body' | 'paper';
  unmount?: () => void;
}

export const LoadingDialog = ({
  unmount,
  maxWidth,
  fullWidth,
  scroll,
}: IProps) => (
  <Dialog
    open={true}
    maxWidth={maxWidth ?? 'lg'}
    fullWidth={fullWidth ?? true}
    scroll={scroll ?? 'paper'}
    onClose={unmount}
  >
    <LoadingSpinner />
  </Dialog>
);
